module.exports = __webpack_public_path__ + "img/horizontal_7_2_pp2_8023.d4f9a83a.png";